import React from 'react'

const ninhBinh = {
    id: 'ninh-binh',
    type: 'post',
    countryId: 'seAsia',
    title: 'A Getaway in Ninh Binh',
    longDate: 'October 26, 2018',
    month: 'Oct',
    date: '26',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/CoverNB.jpg',
    content: [
        {
            text: (
                <div>We have loved Hanoi, but after a week there we were excited to get out of the city and see some of Vietnam's natural beauty. Ninh Binh and the Tam Coc area are only an hour and a half away by bus, so we kept our Airbnb in Hanoi and went out with a backpack for a couple of days.</div>
            )
        },
        {
            text: (
                <div>Getting there was our first experience with busses in Southeast Asia – and it was definitely an adventure! We had booked our tickets online and went to the station to collect them, but the man at the window told us it was canceled. Well actually, he didn't speak English, so he called someone who gave us the news and said the bus company would help us book with another line. Ten minutes, several confused conversations via phone interpreter, and $9 later, we had new tickets – bumming a ride on the sleeper bus to Ho Chi Minh.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/rail.jpg',
        },
        {
            text: (
                <div>The phrase "squished in like sardines" took on new meaning on this bus. All the seats were flat bunk-bed-like pads, organized into three rows stacked two levels high. Since we were late to get on, we went all the way to the back and clambered into what is best described as a crawl space. Then, as more people arrived, they started laying pads on the floor and covered every inch of the bus. Ten minutes away from Ninh Binh, they beckoned us to come sit up front, which involved climbing across the length of the bus without touching the floor. I haven't been that acrobatic since elementary school gymnastics.</div>
            )
        },
        {
            text: (
                <div>Amazingly, the bus manager spoke a little German, which is how we found out the bus would be driving another 20 hours to Ho Chi Minh. Since they wanted to stay on the highway and had taken us on as passengers as a favor to the other company, they didn't drive us into Tam Coc. The bus pulled up to the side of the highway, opened the door, and almost didn't even come to a full stop before letting us off and speeding away. We were mobbed by a taxi and two motorbikes and began the age-old tourist activity of bartering for a ride. Ten minutes and a ridiculously expensive taxi ride later, we made it to Tam Coc!</div>
            )
        },
        {
            text: (
                <div>After fresh pineapple at our awesome "homestay" (really just a bungalow hotel at a crazy low price), we paid $2 to borrow a scooter for the rest of the day. It was our first time on a motorbike (you'd be crazy to try it in Hanoi.)</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/motorbike.jpg',
        },
        {
            text: (
                <div>We headed out to the Bich Dong pagoda 3 kilometers north of town, and encountered our first tourist scam. A woman rushed out to beckon us to the parking area and asked us for the equivalent of $2 for parking and (we assumed) entry to the pagoda; we gladly paid. Turns out the entry to the pagoda is free and this is a common hustle at public attractions. Confusingly, though, at other places when they rushed at us and shouted "ticket!" it was legitimate. We started looking everything up on TripAdvisor ahead of time.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/pagoda.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/pagoda2.jpg',
        },
        {
            text: (
                <div>The pagoda was totally worth getting scammed a couple of bucks. It was beautiful in the afternoon light. It's composed of three levels, with the upper pagoda backing into a cave. Coming out of the cave, we met Dana and Will, a couple from New York on vacation, and invited them to join us for beers after dinner. </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/pagodalake.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/pagodalake2.jpg',
        },
        {
            text: (
                <div>By 3:30, we left to get to the Mua Caves Viewpoint in time for sunset at 5:30. 500 steps later, we were greeted with a stunning view of the Tam Coc river valley. People lounged with beers to watch the sun go down, and we even saw a bride and groom getting their wedding photos taken. Not sure how she made it up there without sweating off her makeup, but I'm sure the photos were stunning.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/muacave2.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/muacave1.jpg',
            detailText: 'The happy couple, at the top of the stairs.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/muacave3.jpg',
        },
        {
            text: (
                <div>The next morning we had intended to get up bright and early for the best photo opportunity on the Tam Coc river boat tour, but… we slept in a little. I'm blaming jetlag. We finally rolled up to the docks at 8:45, still early enough that we missed most of the crowds coming in for day tours from Hanoi. It was peaceful enough for our tour, but  we'd heard it can be a nightmare if you go in the middle of the day when the river is packed with boats. Overall it wasn't my favorite experience; the smog obscured the beauty, and our rower paddled us up to the women selling tchotchkes, then tried to sell us her own wares, and finally straight up asked for a tip. Dana and Will had bought the wares on their boat because they didn't feel there was even a choice; the locals were pretty aggressive about it.</div>
            )
        },
        {
            text: (
                <div>I don't mean to sound too negative about the tourist experience here – it is what it is. People will hustle to make money where there's an opportunity. We haven't encountered it to this degree anywhere outside of Ninh Binh and still had an amazing time there, but if you are someone who gets really rankled by that, just be aware if you visit Vietnam.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/river1.jpg',
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/river3.jpg',
        },
        {
            text: (
                <div>After our boat tour we rented the motorbike again, and drove out to an area called "bird valley." Not sure where the birds were, but there were three awesome caves! At Vai Gioi cave, there are three levels: earth (the entrance), heaven (with a shrine), and hell (the main cave below, covered in dripping limestone formations.) In Mermaid Cave, you walk bent over through a one-track passageway with the walls lit up in bright colors. And Buddha Cave was possibly the coolest: you hire a boat to row into it and can only see what's in the path of your headlamp. It's called Buddha Cave because of a formation of rocks found there that resemble a buddha statue. Bats hung from the ceiling and scattered when you shone your headlamp on them.</div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/NinhBinh/vaigioi.jpg',
        },
        {
            text: (
                <div>On the way back, we stopped for lunch at a sign advertising Bun Rieu Cua, a crab-flavored soup I'd been wanting to try. An old woman served us, then sat next to us watching us eat and occasionally handing us a napkin. It was more maternal than creepy, I swear.</div>
            )
        },
        {
            text: (
                <div>We had a few hours before our return bus but had seen all the sites within a reasonable biking distance, so hung out at the hotel with a beer and books for the afternoon. When an Austrian woman came to reception, she and the English-speaking host couldn't communicate at all about her questions about Tam Coc, and I offered to help her. She was so happy to find someone who spoke German that she chatted to me for the next hour about her trip so far. I understood a little over half and just nodded a lot! Susie was from Hungary originally, but had left because of (as she whispered with a furtive look at the front desk) the communism. I tried to explain that it wasn't taken very seriously in Vietnam nowadays, as evidenced by Cong Caphe, but my vocabulary failed me – so I looked up the word for "joke" in German. Close enough?</div>
            )
        }
    ]
}


export default ninhBinh


// WEBPACK FOOTER //
// ./src/Posts/Content/NinhBinh.js